// extracted by mini-css-extract-plugin
export var actions = "_5-0";
export var actionsContainer = "_5-7";
export var border = "_5-1";
export var childFullHeight = "_5-g";
export var collapse = "_5-2";
export var content = "_5-b";
export var contentChild = "_5-f";
export var fullscreen = "_5-d";
export var hasLeftRadius = "_5-l";
export var headerContainer = "_5-3";
export var headerRow = "_5-5";
export var hidePadding = "_5-c";
export var navCollapsedGap = "_5-m";
export var noScrollX = "_5-n";
export var noScrollY = "_5-o";
export var noTopPadding = "_5-j";
export var optOutTopPadding = "_5-e";
export var pageMain = "_5-k";
export var pageOuter = "_5-h";
export var pagePadding = "_5-8";
export var pageScroll = "_5-9";
export var profile = "_5-p";
export var profileContainer = "_5-q";
export var profileImage = "_5-r";
export var profileMain = "_5-s";
export var profileSubtitle = "_5-u";
export var profileTitle = "_5-t";
export var settingsSurface = "_5-a";
export var showLeftPadding = "_5-i";
export var tabsPortalSlot = "_5-6";
export var tabsWrapper = "_5-4";
export var title = "_5-v";